export { MenuFiltersDrawerController as MenuFiltersDrawer } from './menu-filters-drawer-controller';
